import {
  required,
  emailValidator,
  lengthValidator,
  minValue,
  urlValidator,
} from '@/@core/utils/validation'
import {
  mdiDelete,
  mdiPlus,
  mdiCircleEditOutline,
  mdiFilterOutline,
  mdiFilterVariant,
} from '@mdi/js'

export default {
  account: {
    title: 'Account',
    url: 'crm/accounts',
    key: 'uuid',
    pinned_name_key: 'account',
    module: 'account',
    app: 'crm',
    showSelect: true,
    showImportBtn: true,
    showExportBtn: true,
    showCreateBtn: true,
    actions: [
      { icon: mdiPlus, title: 'Add', ability: 'a' },
      { icon: mdiCircleEditOutline, title: 'Edit', ability: 'e' },
      { icon: mdiDelete, title: 'Delete', ability: 'd' },
      { icon: mdiFilterVariant, title: 'Filter', ability: 'e' },
    ],
    headers: [
      { text: 'Name', value: 'name' },
      { text: 'Email', value: 'email' },
      { text: 'Phone', value: 'phone', sortable: false },
      { text: 'Website', value: 'website', sortable: false },
      { text: 'Action', value: 'action', sortable: false },
    ],
    formFields: [
      {
        type: 'textbox',
        key: 'name',
        fieldLabel: 'Name*',
        validations: [required],
      },
      // {
      //   type: 'dropdown',
      //   key: 'type',
      //   fieldLabel: 'Type',
      //   options: [
      //     { text: 'Customer', value: 'customer' },
      //     { text: 'Vendor', value: 'vendor' },
      //     { text: 'Bidder', value: 'bidder' },
      //   ],
      //   validations: [required],
      // },
      {
        type: 'textbox',
        key: 'email',
        fieldLabel: 'Email',
        validations: [required, emailValidator],
      },
      {
        type: 'textbox',
        key: 'phone',
        fieldLabel: 'Phone*',
        validations: [required, lengthValidator],
      },
      {
        type: 'autocomplete',
        key: 'territory_id',
        fieldLabel: 'Territory*',
        options: [],
        validations: [required],
      },
      {
        type: 'autocomplete',
        key: 'owner_id',
        fieldLabel: 'Owner*',
        validations: [urlValidator],
      },
      {
        type: 'textbox',
        key: 'website',
        fieldLabel: 'Website',
        validations: [urlValidator],
      },
      {
        type: 'textbox',
        key: 'linkedin',
        fieldLabel: 'Linkedin Address',
        validations: [urlValidator],
      },
      {
        type: 'autocomplete',
        key: 'country',
        fieldLabel: 'Country',
        validations: [urlValidator],
      },
      {
        type: 'autocomplete',
        key: 'state',
        fieldLabel: 'State',
        validations: [urlValidator],
      },
      {
        type: 'autocomplete',
        key: 'city',
        fieldLabel: 'City',
        validations: [urlValidator],
      },
      {
        type: 'textbox',
        key: 'postal_code',
        fieldLabel: 'Postal Code',
        validations: [urlValidator],
      },
      {
        type: 'textarea',
        key: 'street_address',
        fieldLabel: 'Address',
        validations: [required],
      },
    ],
  },
  opportunity: {
    title: 'Opportunity',
    url: 'crm/opportunities',
    key: 'uuid',
    module: 'opportunity',
    showSelect: true,
    showImportBtn: true,
    showExportBtn: true,
    showCreateBtn: true,
    app: 'crm',
    actions: [
      {
        icon: mdiPlus,
        title: 'Add',
        ability: 'a',
      },
      {
        icon: mdiCircleEditOutline,
        title: 'Edit',
        ability: 'e',
      },
      {
        icon: mdiDelete,
        title: 'Delete',
        ability: 'd',
      },
      { icon: mdiFilterOutline, title: 'Filter', ability: 'e' },
    ],
    headers: [
      {
        text: 'Name',
        value: 'name',
      },
      {
        text: 'owner',
        value: 'owner_name',
        sortable: false,
      },
      {
        text: 'Primary Account',
        value: 'account_name',
        sortable: false,
      },
      {
        text: 'Bid Date',
        value: 'bidAt',
        sortable: false,
      },
      {
        text: 'Revenue',
        value: 'revenue',
        sortable: false,
      },
      {
        text: 'Stage',
        value: 'stage',
        sortable: false,
      },
      {
        text: 'Close Date',
        value: 'closedAt',
        sortable: false,
      },
      { text: 'Action', value: 'action', sortable: false },
    ],
    formFields: [
      {
        type: 'textbox',
        key: 'name',
        fieldLabel: 'Name*',
        validations: [required],
      },
      {
        type: 'autocomplete',
        key: 'account_id',
        fieldLabel: 'Account',
        'item-value': '_id',
        'item-text': 'name',
        api: '/crm/accounts',
        options: [],
        search: '',
        validations: [],
      },
      {
        type: 'autocomplete',
        key: 'stage',
        fieldLabel: 'Stage*',
        validations: [required],
      },
      {
        type: 'number',
        key: 'revenue',
        fieldLabel: 'Revenue',
        validations: [minValue],
      },
      {
        type: 'date',
        key: 'closedAt',
        fieldLabel: 'Closed At*',
        validations: [],
      },
      {
        type: 'date',
        key: 'bidAt',
        fieldLabel: 'Bid At',
        validations: [],
      },
      {
        type: 'autocomplete',
        key: 'territory_id',
        fieldLabel: 'Territory*',
        options: [],
        validations: [required],
      },
      {
        type: 'textbox',
        key: 'owner',
        fieldLabel: 'Owner*',
        validations: [required],
      },
      {
        type: 'textbox',
        key: 'lostReason',
        fieldLabel: 'Lost Resaon',
        validations: [],
      },
      {
        type: 'textbox',
        key: 'country',
        fieldLabel: 'Country',
        validations: [urlValidator],
      },
      {
        type: 'textbox',
        key: 'state',
        fieldLabel: 'State',
        validations: [urlValidator],
      },
      {
        type: 'textbox',
        key: 'city',
        fieldLabel: 'City',
        validations: [urlValidator],
      },
      {
        type: 'textbox',
        key: 'postal_code',
        fieldLabel: 'Postal Code',
        validations: [urlValidator],
      },
      {
        type: 'textarea',
        key: 'street_address',
        fieldLabel: 'Address',
        validations: [],
      },
      {
        type: 'textarea',
        key: 'description',
        fieldLabel: 'Description',
        validations: [],
      },
    ],
  },
  contact: {
    title: 'Contact',
    url: 'crm/contacts',
    key: 'uuid',
    module: 'contact',
    app: 'crm',
    showSelect: true,
    showImportBtn: true,
    showExportBtn: true,
    showCreateBtn: true,
    actions: [
      {
        icon: mdiPlus,
        title: 'Add',
        ability: 'a',
      },
      {
        icon: mdiCircleEditOutline,
        title: 'Edit',
        ability: 'e',
      },
      {
        icon: mdiDelete,
        title: 'Delete',
        ability: 'd',
      },
      { icon: mdiFilterOutline, title: 'Filter', ability: 'e' },
    ],
    headers: [
      {
        text: 'Name',
        value: 'name',
      },
      {
        text: 'Email',
        value: 'email',
      },
      {
        text: 'Designation',
        value: 'designation',
        sortable: false,
      },
      {
        text: 'Phone',
        value: 'phone',
        sortable: false,
      },
      {
        text: 'Mobile',
        value: 'mobile',
        sortable: false,
      },
      { text: 'Action', value: 'action', sortable: false },
    ],
    formFields: [
      {
        type: 'textbox',
        key: 'name',
        fieldLabel: 'Name*',
        validations: [required],
      },
      {
        type: 'textbox',
        key: 'email',
        fieldLabel: 'Email*',
        validations: [required, emailValidator],
      },
      {
        type: 'textbox',
        key: 'phone',
        fieldLabel: 'Work Phone*',
        validations: [required, lengthValidator],
      },
      {
        type: 'textbox',
        key: 'mobile',
        fieldLabel: 'Mobile',
        validations: [lengthValidator],
      },
      {
        type: 'autocomplete',
        key: 'account_id',
        fieldLabel: 'Account*',
        'item-value': '_id',
        'item-text': 'name',
        api: '/crm/accounts',
        options: [],
        search: '',
        validations: [],
      },
      {
        type: 'dropdown',
        key: 'mode_of_communication',
        fieldLabel: 'Mode of Communication',
        options: [
          { text: 'SMS', value: 'SMS' },
          { text: 'Email', value: 'Email' },
        ],
        validations: [],
      },
      {
        type: 'textbox',
        key: 'designation',
        fieldLabel: 'Position',
        validations: [],
      },
      {
        type: 'textbox',
        key: 'linkedin',
        fieldLabel: 'Linkedin Address',
        validations: [urlValidator],
      },
      {
        type: 'textbox',
        key: 'country',
        fieldLabel: 'Country',
        validations: [urlValidator],
      },
      {
        type: 'textbox',
        key: 'state',
        fieldLabel: 'State',
        validations: [urlValidator],
      },
      {
        type: 'textbox',
        key: 'city',
        fieldLabel: 'City',
        validations: [urlValidator],
      },
      {
        type: 'textbox',
        key: 'postal_code',
        fieldLabel: 'Zip Code',
        validations: [urlValidator],
      },
      {
        type: 'textarea',
        key: 'street_address',
        fieldLabel: 'Address',
        validations: [],
      },
    ],
  },
  lead: {
    title: 'Lead',
    url: 'crm/leads',
    key: 'uuid',
    module: 'lead',
    app: 'crm',
    showSelect: true,
    showImportBtn: true,
    showExportBtn: true,
    showCreateBtn: true,
    actions: [
      { icon: mdiPlus, title: 'Add', ability: 'a' },
      { icon: mdiCircleEditOutline, title: 'Edit', ability: 'e' },
      { icon: mdiDelete, title: 'Delete', ability: 'd' },
      { icon: mdiFilterOutline, title: 'Filter', ability: 'e' },
    ],
    headers: [
      { text: 'Name', value: 'name' },
      { text: 'Email', value: 'email' },
      {
        text: 'Owner',
        value: 'owner_name',
        sortable: false,
      },
      { text: 'Company', value: 'company', sortable: false },
      { text: 'Opportunity', value: 'opportunity', sortable: false },
      { text: 'Phone', value: 'phone', sortable: false },
      { text: 'Status', value: 'lead_status', sortable: false },
      { text: 'Revenue', value: 'revenue', sortable: false },
      { text: 'Action', value: 'action', sortable: false },
    ],
    formFields: [
      {
        type: 'textbox',
        key: 'name',
        fieldLabel: 'Name*',
        validations: [required],
      },
      {
        type: 'textbox',
        key: 'title',
        fieldLabel: 'Title*',
        validations: [required],
      },
      {
        type: 'textbox',
        key: 'email',
        fieldLabel: 'Email*',
        validations: [required, emailValidator],
      },
      {
        type: 'textbox',
        key: 'phone',
        fieldLabel: 'Phone*',
        validations: [required, lengthValidator],
      },
      {
        type: 'dropdown',
        key: 'source',
        fieldLabel: 'Lead Source*',
        options: [
          { text: 'Phone', value: 0 },
          { text: 'Web', value: 1 },
          { text: 'Referral', value: 2 },
          { text: 'Other', value: 4 },
        ],
        validations: [required],
      },
      {
        type: 'dropdown',
        key: 'lead_status',
        fieldLabel: 'Lead Status',
        options: [
          { text: 'Open', value: 0 },
          { text: 'Working', value: 1 },
          { text: 'Closed', value: 2 },
          { text: 'Converted', value: 3 },
        ],
        validations: [required],
      },
      {
        type: 'autocomplete',
        key: 'territory_id',
        fieldLabel: 'Territory*',
        options: [],
        validations: [required],
      },
      {
        type: 'date',
        key: 'startDate',
        fieldLabel: 'Date',
        validations: [],
      },
      {
        type: 'textbox',
        key: 'mobile',
        fieldLabel: 'Mobile',
        validations: [lengthValidator],
      },
      {
        type: 'textbox',
        key: 'company',
        fieldLabel: 'Company',
        validations: [required],
      },
      {
        type: 'textbox',
        key: 'opportunity',
        fieldLabel: 'Opportunity',
        validations: [required],
      },
      {
        type: 'textbox',
        key: 'country',
        fieldLabel: 'Country',
        validations: [urlValidator],
      },
      {
        type: 'textbox',
        key: 'state',
        fieldLabel: 'State',
        validations: [urlValidator],
      },
      {
        type: 'textbox',
        key: 'city',
        fieldLabel: 'City',
        validations: [urlValidator],
      },
      {
        type: 'textbox',
        key: 'postal_code',
        fieldLabel: 'Zip Code',
        validations: [urlValidator],
      },
      {
        type: 'textarea',
        key: 'street_address',
        fieldLabel: 'Address',
        validations: [],
      },
      {
        type: 'textarea',
        key: 'description',
        fieldLabel: 'Description',
        validations: [],
      },
    ],
  },
  dashboard: {
    account: {
      title: 'Accounts',
      url: 'crm/dashboards/accounts',
      key: 'uuid',
      pinned_name_key: 'account',
      module: 'account',
      app: 'crm',
      headers: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Phone', value: 'phone', sortable: false },
        { text: 'Website', value: 'website', sortable: false },
      ],
    },
    tasks: {
      title: 'Recent Task',
      url: '/task-management/myTasks',
      key: 'uuid',
      pinned_name_key: 'recent_task',
      module: 'task',
      app: 'taskManagement',
      headers: [
        { text: 'Task Name', value: 'name', sortable: false },
        { text: 'Assignee', value: 'assignee.name' },
        { text: 'Task Workflow Status', value: 'workflow_status.name', sortable: false },
        { text: 'Deadline', value: 'due_date' },
      ],
    },
    top_account: {
      title: 'Top Accounts',
      url: '/crm/dashboards/top/revenues/accounts',
      pinned_name_key: 'top_account',
      key: 'uuid',
      module: 'account',
      app: 'crm',
      headers: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Phone', value: 'phone', sortable: false },
        { text: 'Website', value: 'website', sortable: false },
        { text: 'Revenue', value: 'opportunitiesrevenuecount', sortable: false },
      ],
    },
    accounts_chart: {
      title: 'ACCOUNTS CHART',
      url: '/crm/dashboards/accounts/type',
      key: 'uuid',
      module: 'account',
      app: 'crm',
      type: 'donut',
    },
    revenue_chart: {
      title: 'Revenue By Month',
      url: '/crm/dashboards/revenues/details',
      key: 'uuid',
      module: 'opportunity',
      app: 'crm',
      type: 'bar',
    },
    lost_win_chart: {
      // title: 'Opportunities Lost/ Win',
      title: 'Opportunities By Stages',
      url: '/crm/dashboards/opportunities/stages',
      key: 'uuid',
      module: 'opportunity',
      app: 'crm',
      type: 'pie',
    },
    opportunity_stages: {
      title: 'Opportunities Lost/ Win',
      url: '/crm/dashboards/opportunities/stages',
      key: 'uuid',
      module: 'opportunity',
      app: 'crm',
      type: 'bar',
    },
  },
}
